module.exports = __webpack_public_path__ + "img/20_97.0ec3ae64.png";